<template>
    <router-view appear :key="path"></router-view>
</template>


<script>
export default {
  name: "MainModule",
  components: {},
  data: () => ({
    path: null
  }),
};
</script>
